import React, { ComponentProps } from 'react';
import { asView } from '../../../../_lib/ViewFetcher';

import { AccessLevelData } from '../../common/types';
import { AccessLevelInformation } from '../../common/partials/AccessLevelInformation';
import { AccessLevelInfoRequestFormTypes } from '../../common/forms/AccessLevelInfoRequestForm';

export type CurrentAccessLevelDefaultViewProps = {
  currentAccessLevel: AccessLevelData;
  createRequestForm?: AccessLevelInfoRequestFormTypes;
};

function CurrentAccessLevelDefault(props: CurrentAccessLevelDefaultViewProps) {
  return <AccessLevelInformation accessLevelDetails={props.currentAccessLevel} />;
}

export const CurrentAccessLevelDefaultView = asView(CurrentAccessLevelDefault);
export type CurrentAccessLevelDefaultView = ComponentProps<typeof CurrentAccessLevelDefaultView>;
